import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 获取商家账号信息
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/member/getMemberInfo/${params}`),
    // 获取商家功能模块
    gets: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/member/getMenu`, params),
    // 获取商家产品信息
    getpro: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/front/product/getMemberProductList/${params}`),
    // 修改商家简介和联系方式
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/brand/saveBrand`, params),
    //修改用户昵称
    updates: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/updateSelfInfo`, params),
    //删除商家品牌和图片和视频
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/brand/deleteBrandByType`, params),
    //修改个人头像
    uparl: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/updateAvatar`, params),
}